<template>
  <v-card class="mb-12 pb-3" min-height="200px">
    <v-form ref="form" id="firstStepForm" @submit.prevent="submit"> </v-form>
    <v-container>
      <v-row>
        <v-col cols="12" md="4" class="mb-0 pb-0">
          <v-select
            v-show="!instant"
            :items="translatedStatuses"
            v-model="adminStatusId"
            item-value="id"
            item-text="title"
            label="Статус"
          ></v-select>
          <v-text-field
            v-show="instant"
            :value="translatedCurrentStatus"
            label="Статус"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" class="mb-0 pb-0">
          <v-select
            v-show="!instant"
            v-model="profileTagIds"
            :items="translatedTags"
            label="Теги"
            multiple
            chips
            clearable
            deletable-chips
            item-value="id"
            item-text="title"
          ></v-select>
          <v-text-field
            v-show="instant"
            :value="translatedCurrentTags"
            label="Теги"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3" class="mb-0 pb-0">
          <p class="mb-0">
            {{
              $vuetify.lang.t(
                "$vuetify.main.adminDashboard.psychologists.stepsTitle.generalInformation"
              )
            }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4" class="pt-0">
          <!--            :typeOfTextfield="'lastnameRulesUA'"-->

          <v-text-field
            id="surname.uk"
            form="firstStepForm"
            v-show="!instant"
            v-model="psychologistsList.translated.surname.uk"
            label="Прізвище"
            filled
          ></v-text-field>
          <v-text-field
            v-show="instant"
            v-model="backupList.translated.surname.uk"
            label="Прізвище"
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4" class="pt-0">
          <!--            :typeOfTextfield="'nameRulesUA'"-->

          <v-text-field
            id="name.uk"
            form="firstStepForm"
            v-show="!instant"
            v-model="psychologistsList.translated.name.uk"
            label="Ім'я"
            filled
          ></v-text-field>
          <v-text-field
            v-show="instant"
            v-model="backupList.translated.name.uk"
            label="Ім'я"
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4" class="pt-0">
          <v-text-field
            id="middle_name.uk"
            form="firstStepForm"
            v-show="!instant"
            v-model="psychologistsList.translated.middle_name.uk"
            label="По батькові"
            filled
          ></v-text-field>
          <v-text-field
            v-show="instant"
            v-model="backupList.translated.middle_name.uk"
            label="По батькові"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <!--            :typeOfTextfield="'dateOfBirth'"-->

          <v-text-field
            form="firstStepForm"
            id="birthday"
            v-show="!instant"
            v-model="psychologistsList.birthday"
            :label="
              $vuetify.lang.t(
                '$vuetify.main.adminDashboard.psychologists.inputLabel.main.stepOne.dateOfBirth'
              )
            "
            filled
          ></v-text-field>
          <v-text-field
            v-show="instant"
            v-model="backupList.birthday"
            :label="
              $vuetify.lang.t(
                '$vuetify.main.adminDashboard.psychologists.inputLabel.main.stepOne.dateOfBirth'
              )
            "
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <!--            :typeOfTextfield="'citizenshipRules'"-->

          <v-text-field
            id="citizenship"
            form="firstStepForm"
            v-show="!instant"
            v-model="psychologistsList.citizenship"
            :label="
              $vuetify.lang.t(
                '$vuetify.main.adminDashboard.psychologists.inputLabel.main.stepOne.citizenship'
              )
            "
            filled
          ></v-text-field>
          <v-text-field
            v-show="instant"
            v-model="backupList.citizenship"
            :label="
              $vuetify.lang.t(
                '$vuetify.main.adminDashboard.psychologists.inputLabel.main.stepOne.citizenship'
              )
            "
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-show="!instant"
            :items="sexList"
            v-model="sexValue"
            item-value="id"
            item-text="title"
            :label="
              $vuetify.lang.t(
                `$vuetify.main.psychologistReg.stepOne.sex`
              )
            "
          ></v-select>
          <v-text-field
            v-show="instant"
            v-model="backupList.sex"
            :label="
              $vuetify.lang.t(
                '$vuetify.main.psychologistReg.stepOne.sex'
              )
            "
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <!--            :typeOfTextfield="'emailRules'"-->

          <v-text-field
            id="email"
            form="firstStepForm"
            v-show="!instant"
            v-model="psychologistsList.email"
            label="Email:"
            filled
          ></v-text-field>
          <v-text-field
            v-show="instant"
            v-model="backupList.email"
            label="Email:"
            readonly
          ></v-text-field>
        </v-col>
        <v-col col="12" md="4">
          <vue-phone-number-input
            v-model="psychologistsList.phone"
            :default-country-code="defaultCountry"
            :preferred-countries="countriesList"
            :loader="hasLoaderActive"
            :error="hasErrorActive"
            :translations="translations"
            @update="updatedPhone"
            show-code-on-list
            :required="false"
            :disabled="instant"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="12" md="3">
          <p class="mb-0">
            {{
              $vuetify.lang.t(
                "$vuetify.main.adminDashboard.psychologists.inputLabel.questionnaire.stepOne.education"
              )
            }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <div
            v-for="(item, index) in educationItems"
            :key="index"
          >
            <v-card class="mb-4">
              <v-card-subtitle>
                <div class="d-flex align-center">
                  <div class="flex-grow-1">
                    {{ $vuetify.lang.t("$vuetify.main.psychologistReg.stepOne.education") }} №{{index + 1}}
                  </div>

                  <div class="ml-2">
                    <div>
                      <v-btn
                        icon
                        color="red"
                        class="ed-remove-btn"
                        @click="removeEdItem(index)"
                        :disabled="educationItems.length === 1"
                        v-show="!instant"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </v-card-subtitle>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="item.year"
                      :label="
                        $vuetify.lang.t(
                          `$vuetify.main.psychologistReg.stepOne.yearOfEnding`
                        )
                      "
                      type="text"
                      form="firstStepForm"
                      :rules="yearRules"
                      class="mt-0 pt-0"
                      :readonly="instant"
                      :filled="!instant"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="10">
                    <v-text-field
                      v-model="item.desc_uk"
                      label="Опис"
                      type="text"
                      form="firstStepForm"
                      :rules="descRulesUA"
                      class="mt-0 pt-0"
                      :readonly="instant"
                      :filled="!instant"
                    ></v-text-field>
                  </v-col>

                </v-row>
              </v-card-text>
            </v-card>
          </div>

          <div class="d-flex mt-2 mb-5">
            <v-btn
              color="primary"
              @click="addEdItem"
              :disabled="educationItems.length >= 20"
              v-show="!instant"
            >
              {{ $vuetify.lang.t(`$vuetify.main.psychologistReg.stepOne.add_education`) }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="mb-0 pb-0">
          <p class="mb-0 pb-0">
            {{
              $vuetify.lang.t(
                "$vuetify.main.adminDashboard.psychologists.inputLabel.questionnaire.stepOne.certificatesTitle"
              )
            }}
          </p>
        </v-col>
      </v-row>
      <v-row
        v-for="certificate in psychologistsList.certificates"
        :key="certificate.title"
      >
        <span class="mr-2 pt-2 pl-4"> {{ certificate.title }} : </span>
        <v-btn
          class="mt-2"
          color="primary"
          small
          :href="certificate.url"
          download
          target="_blank"
          >{{
            $vuetify.lang.t(
              "$vuetify.main.adminDashboard.psychologists.buttons.download"
            )
          }}</v-btn
        >
      </v-row>
    </v-container>
    <!--    <button form="firstStepForm" type="submit">dsaddsa</button>-->
  </v-card>
</template>

<script>
import prepareData from "@/mixins/prepareData.js";
import updateData from "@/mixins/updateData";
import Vue from "vue";
export default {
  name: "stepOne",
  mixins: [prepareData, updateData],

  data() {
    return {
      payload: {},
      backupList: {},
      userData: null,
      scienceValue: "",
      sex: "",
      defaultCountry: "",
      countriesList: ["UA", "RU", "BY", "MD"],
      hasLoaderActive: false,
      hasErrorActive: false,
      loader: null,
      educationItems: [{ year: "", desc_uk: "", desc_ru: "" }],
    };
  },
  props: {
    psychologistsList: Object,
    instantValue: Boolean,
    saveIsNeed: Boolean,
  },
  created() {
    this.backupList = JSON.parse(JSON.stringify(this.psychologistsList)); // делаем независимую копию обьекта
    this.scienceValue = this.psychologistsList.education_degree_value;
    this.sexValue = this.psychologistsList.sex_value;
    this.defaultCountry = this.psychologistsList.phone_country_code;
    this.adminStatusId = this.psychologistsList.admin_status_id;
    this.profileTagIds = this.psychologistsList.profile_tag_ids;

    this.educationItems = [];
    if (this.backupList.translated.education.ru && this.backupList.translated.education.uk) {
      this.backupList.translated.education.ru.forEach((edItem, index) => {
        if (this.backupList.translated.education.uk[index] && this.backupList.translated.education.uk[index].year == edItem.year) {
          this.educationItems.push({ 
            year: edItem.year, 
            desc_uk: this.backupList.translated.education.uk[index].desc,
            desc_ru: edItem.desc, 
          });
        }
      });
    }
  },
  watch: {
    saveIsNeed() {
      if (this.saveIsNeed) this.submit();
    },
    userData() {
      let countryCode = this.userData.countryCode;
      let nationalNumber = this.userData.nationalNumber;
      switch (countryCode) {
        case "UA":
          if (nationalNumber) {
            if (Array.from(nationalNumber).length > 9) {
              this.hasErrorActive = true;
              this.userData.isValid = false;
            } else {
              this.hasErrorActive = false;
            }
          }
      }
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    },
  },
  computed: {
    translatedCurrentStatus() {
      return this.$vuetify.lang.t(`$vuetify.main.adminDashboard.psychologists.admin_status.${this.backupList.admin_status_id}`);
    },
    translatedCurrentTags() {
      const ids = this.backupList.profile_tag_ids;

      if (!ids || !ids.length) {
        return 'Без тегів'
      }

      return ids
        .map(id => {
          return this.$vuetify.lang.t(
            `$vuetify.main.adminDashboard.psychologists.profile_tag.${id}`
          )
        })
        .join(', ')
    },
    translatedStatuses() {
      return [1, 2, 3, 4, 5, 6, 7, 8].map(i => ({
        id: i,
        title: this.$vuetify.lang.t(`$vuetify.main.adminDashboard.psychologists.admin_status.${i}`)
      }));
    },
    translatedTags() {
      return [1, 2].map(i => ({
        id: i,
        title: this.$vuetify.lang.t(`$vuetify.main.adminDashboard.psychologists.profile_tag.${i}`)
      }));
    },
    yearRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.yearRules1"
          ),
        (v) =>
          v.length === 4 ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.yearRules2"
          ),
      ];
    },
    descRules() {
      return [(v) => !!v || this.$vuetify.lang.t("$vuetify.main.psychologistReg.stepOne.descRules")];
    },
    descRulesUA() {
      return [(v) => !!v || this.$vuetify.lang.t("$vuetify.main.psychologistReg.stepOne.descRulesUA")];
    },
    instant() {
      return this.instantValue;
    },
    getPhoneCountryCode() {
      return this.$store.getters["user/getUserPhoneCountryCode"];
    },
    sexList() {
      return [
        {
          id: 0,
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.female"
          ),
        },
        {
          id: 1,
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.male"
          ),
        }
      ];
    },
    scienceDegreeList() {
      return [
        {
          id: "bachelors",
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.bachelors"
          ),
        },
        {
          id: "master",
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.master"
          ),
        },
        {
          id: "doctoral",
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.doctoral"
          ),
        },
        {
          id: "candidate_of_sciences",
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.candidate_of_sciences"
          ),
        },
      ];
    },
    translations() {
      return {
        countrySelectorLabel: this.$vuetify.lang.t(
          "$vuetify.view.signIn.countrySelectorLabel"
        ),
        countrySelectorError: this.$vuetify.lang.t(
          "$vuetify.view.signIn.countrySelectorError"
        ),
        phoneNumberLabel: this.$vuetify.lang.t(
          "$vuetify.view.signIn.phoneNumberLabel"
        ),
        example: this.$vuetify.lang.t("$vuetify.view.signIn.example"),
      };
    },
  },
  methods: {
    addEdItem() {
      if (this.educationItems.length < 20) {
        this.educationItems.push({ year: "", desc_uk: "", desc_ru: "" });
      }
    },
    removeEdItem(index) {
      if (this.educationItems.length > 1) {
        this.educationItems.splice(index, 1);
      }
    },
    updatedPhone(data) {
      this.userData = data;
    },
    submit() {
      if (this.psychologistsList.phone && this.userData && !this.userData.isValid) {
        Vue.swal({
          target: document.getElementById("main"),
          text: this.$vuetify.lang.t(
            "$vuetify.main.adminDashboard.psychologists.swalText.invalidPhone"
          ),
          icon: "error",
          timer: 4000,
          toast: true,
          position: "top-right",
          showConfirmButton: false,
        });
      } else {
        let data = Array.from(this.$refs.form.$el.elements);
        data.forEach((el) => {
          this.prepareData(el);
        });
        this.updateData();
      }
    },
  },
};
</script>

<style scoped></style>
